import { application } from "../stimulus_application"
import { definitions } from "stimulus:."

application.load(definitions)
